<div style="min-height: 100vh;" class="container py-4">
  <div class="d-flex flex-column flex-sm-row justify-content-between align-items-center">
    <h4 class="mb-0" style="font-size: 1.3em;">Welcome <strong>{{userProfile.name | lowercase}}</strong> to the <span class="company-name">{{userProfile.currentCompany | titlecase}}</span> Portal</h4>
    <button class="btn btn-primary" (click)="openUserPage()"><span class="pr-2"><i class="fas fa-user-circle"></i></span>My Profile</button>
  </div>
  <br />
  <div class="d-flex justify-content-around flex-wrap pb-4">
    <div class="card home-card" style="border-left: 6px solid #0f75bc; min-width: 300px">
      <div class="card-body pointer-cursor">
        <h5 class="card-title" routerLink="../Portal/reportlist"><strong>Portal</strong></h5>
        <div class="d-flex justify-content-between" style="padding-top: 1.3rem;">
          <a class="btn btn-sm btn-outline-primary" style="color: black;" routerLink="../Portal/reportlist">Reports</a>
          <a *ngIf="showDashboards" class="btn btn-sm btn-outline-primary" style="color: black;" routerLink="../Portal/dashboardlist">Dashboards</a>
        </div>
      </div>
    </div>
    <div class="card home-card" style="border-left: 6px solid #ecb307; min-width: 300px">
      <div class="card-body">
        <h5 class="card-title pointer-cursor" routerLink="../ControlPanel/users"><strong>Control Panel</strong></h5>
        <div class="d-flex justify-content-between" style="padding-top: 1.3rem;">
          <a class="btn btn-sm btn-outline-warning" style="color: black;" routerLink="../ControlPanel/users">Users</a>
          <a class="btn btn-sm btn-outline-warning" style="color: black;" routerLink="../ControlPanel/wells">Wells</a>
        </div>
      </div>
    </div>
    
  </div>

 <!-- <div class="alert alert-success" role="alert">
    <p class="mb-0">
      <i class="fas fa-bullhorn pr-2"></i> RigReport 0.6.4 release is now live. Click to see updates.
    </p>
  </div>-->

  <div class="py-4">
    <div class="row">
      <div class="col-md-6">
        <div class="card home-card">
          <h5 class="card-header">Quick Links</h5>
          <div class="card-body">
            <ul>
              <li><a routerLink="../ControlPanel/users/user/create">Create a User</a></li>
              <li><a routerLink="../ControlPanel/users">Edit Users</a></li>
              <li><a routerLink="../ControlPanel/wells/add">Add a Well</a></li>
              <li><a routerLink="../ControlPanel/wells">Edit Wells</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card home-card">
          <h5 class="card-header">Favorite Reports</h5>
          <div class="card-body">
            <div *ngIf="isLoadingReports">
              <app-loading-indicator></app-loading-indicator>
            </div>
            <div *ngIf="!isLoadingReports && (favoriteReports.reports.length == 0)" class="text-center">
              <p class="mb-0"><em>You do not have any favorite reports.</em></p>
              <p class="mb-0"><span class="pr-2 favorited-icon"><i class="fas fa-star"></i></span> a <a routerLink="../Portal/reportlist">Report</a> to add it as a favorite</p>
            </div>
            <table class="table table-striped mi4-home-favorites-table" *ngIf="!isLoadingReports">
              <tbody>
                <ng-container *ngFor="let report of favoriteReports.reports; index as i">
                  <tr *ngIf="i <= 3">
                    <td>
                      <a href="{{reportServer}}Default?reportid={{report.reportID}}" title="{{report.reportDescription}}" target="_blank">{{report.reportName}}</a>
                    </td>
                    <td class="text-right">
                      <span class="text-muted"><em>{{report.reportGroup}}</em></span>
                    </td>
                  </tr>
                  <ng-container *ngIf="allFavoritesVisible">
                    <tr *ngIf="i > 3">
                      <td>
                        <a href="{{reportServer}}Default?reportid={{report.reportID}}" title="{{report.reportDescription}}" target="_blank">{{report.reportName}}</a>
                      </td>
                      <td class="text-right">
                        <span class="text-muted"><em>{{report.reportGroup}}</em></span>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
            <div class="text-center" *ngIf="!isLoadingReports && (favoriteReports.reports.length > 4) && !allFavoritesVisible">
              <button class="btn btn-sm btn-outline-dark" (click)="showAllFavorites()">Show All</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</div>
